import React from 'react';
import styled from 'styled-components';
import {IconButton} from '@mui/material';
import WidthFullTwoToneIcon from '@mui/icons-material/WidthFullTwoTone';
import WidthNormalTwoToneIcon from '@mui/icons-material/WidthNormalTwoTone';
import {NumberInput} from './NumberInput';

const Label = styled.span`
  font-size: 16px;
`;

export function PdfScale({
  scale,
  onChange,
  fit,
  onFitClick,
}: {
  scale: number;
  onChange: (val: number) => void;
  fit: string | null;
  onFitClick: () => void;
}) {
  function toPercent(num: number) {
    return Math.floor(num * 100);
  }

  function handleChange(num: number) {
    onChange(num / 100);
  }

  return (
    <>
      <Label>ଆକାର</Label>
      <NumberInput
        value={toPercent(scale)}
        onChange={handleChange}
        min={1}
        max={500}
        step={25}
      />
      <IconButton
        size="small"
        aria-label={fit === 'page' ? 'Fit to page' : 'Fit to width'}
        onClick={onFitClick}
      >
        {fit === 'page' ? (
          <WidthFullTwoToneIcon fontSize="small" />
        ) : (
          <WidthNormalTwoToneIcon fontSize="small" />
        )}
      </IconButton>
    </>
  );
}
